import { gql } from "@apollo/client";

export const GET_QUICK_FILTERS = gql`
  query GetQuickFilters($target: String!) {
    me {
      id
      quickFilters(target: $target) {
        id
        name
        isDefault
        config
      }
    }
  }
`;

export const UPSERT_QUICK_FILTER = gql`
  mutation UpsertQuickFilter(
    $id: String
    $target: String!
    $name: String!
    $config: JSONObject!
  ) {
    upsertQuickFilter(id: $id, target: $target, name: $name, config: $config) {
      id
      name
      config
    }
  }
`;

export const REORDER_QUICK_FILTERS = gql`
  mutation ReorderQuickFilters($ids: [String!]!, $target: String!) {
    reorderQuickFilters(ids: $ids, target: $target)
  }
`;

export const DELETE_QUICK_FILTER = gql`
  mutation DeleteQuickFilter($id: String!, $target: String!) {
    deleteQuickFilter(id: $id, target: $target)
  }
`;

export const SYNC_QUICK_FILTERS = gql`
  mutation SyncQuickFilters($target: String!) {
    syncQuickFilters(target: $target)
  }
`;
